import TaskModel from "../../models/responses/task.model";
import FirebaseUsage from "../../firebase/firebase.usage";
import {COLLECTIONS} from "../../firebase/constants";
import {MessageType} from "../../models/responses/message.model";
import {UserDocModel} from "../../models/responses/user.model";
import store from "../../store/store";
import {WorkPackage} from "../../models/responses/work-package.model";


export default class ChecklistUtils {
    public static async completeCheckListItem(itemId: string, task: TaskModel, contractId: string, user: UserDocModel) {
        const ledgerDoc = FirebaseUsage.getBlankDoc(COLLECTIONS.LEDGER_ENTRY)
        const ledgerEntry = {
            taskId: task.task_id,
            taskCode: task.task_code,
            projectId: task.projectId,
            contractId: contractId,
            timestamp: FirebaseUsage.timestamp(),
            logTimestamp: FirebaseUsage.timestamp(),
            type: MessageType.CIC,
            checklistItemId: itemId,
            ledgerId: ledgerDoc.id,
            userId: user.userId,
            userEmail: user.userEmail
        }

        await FirebaseUsage.updateDoc(COLLECTIONS.TASKS, task.task_id, task.completedChecklist ?
            {
                completedChecklist: [
                    ...task.completedChecklist,
                    {id: itemId, timestamp: FirebaseUsage.timestamp()}]
            } :
            {completedChecklist: [{id: itemId, timestamp: FirebaseUsage.timestamp()}]})
        await FirebaseUsage.setDocumentWithDoc(ledgerDoc, ledgerEntry)
    }

    public static async uncheckCheckListItem(itemId: string, task: TaskModel, contractId: string, user: UserDocModel) {
        const ledgerDoc = FirebaseUsage.getBlankDoc(COLLECTIONS.LEDGER_ENTRY)
        const ledgerEntry = {
            taskId: task.task_id,
            taskCode: task.task_code,
            projectId: task.projectId,
            contractId: contractId,
            timestamp: FirebaseUsage.timestamp(),
            logTimestamp: FirebaseUsage.timestamp(),
            type: MessageType.CIU,
            checklistItemId: itemId,
            ledgerId: ledgerDoc.id,
            userId: user.userId,
            userEmail: user.userEmail
        }

        const completedChecklistMap = store.getState().task.completedChecklistMap;
        completedChecklistMap.delete(`${task.task_id}:${itemId}`);
        await FirebaseUsage.updateDoc(COLLECTIONS.TASKS, task.task_id, task.completedChecklist ?
            {
                completedChecklist: [
                    ...task.completedChecklist.filter((item) => item.id !== itemId)]
            } :
            {completedChecklist: []})
        await FirebaseUsage.setDocumentWithDoc(ledgerDoc, ledgerEntry)
    }

    public static async addChecklistAttachment(
        taskId: string,
        checklistItemId: string,
        attachmentId: string,
        attachmentName: string
    ) {
        const allTasks = store.getState().task.tasks;
        let task = allTasks.get(taskId);
        if (!task || !task.completedChecklist) return;
        const completedChecklist = task.completedChecklist.map((item) =>
            item.id === checklistItemId ? ({
                ...item,
                attachments: item.attachments ?
                    [...item.attachments, {id: attachmentId, name: attachmentName}] :
                    [{id: attachmentId, name: attachmentName}]
            }) : item
        )
        await FirebaseUsage.updateDoc(COLLECTIONS.TASKS, task.task_id, {
            completedChecklist: completedChecklist
        })
    }

    public static async removeChecklistAttachment(
        taskId: string,
        checklistItemId: string,
        attachmentId: string
    ) {
        const allTasks = store.getState().task.tasks;
        let task = allTasks.get(taskId);
        if (!task || !task.completedChecklist) return;
        const completedChecklist = task.completedChecklist.map((item) =>
            item.id === checklistItemId ? ({
                ...item,
                attachments: item.attachments ?
                    item.attachments.filter((attachment) => attachment.id !== attachmentId) :
                    []
            }) : item
        )
        await FirebaseUsage.updateDoc(COLLECTIONS.TASKS, task.task_id, {
            completedChecklist: completedChecklist
        })
        await FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_FILES, attachmentId, {
            deleted: true
        })
    }

    public static async completeWorkPackageChecklistItem(
        workPackage: WorkPackage,
        itemId: string,
        contractId: string,
        user: UserDocModel
    ) {
        const ledgerDoc = FirebaseUsage.getBlankDoc(COLLECTIONS.LEDGER_ENTRY)
        const ledgerEntry = {
            projectId: workPackage.projectId,
            contractId: contractId,
            timestamp: FirebaseUsage.timestamp(),
            logTimestamp: FirebaseUsage.timestamp(),
            type: MessageType.CIC,
            checklistItemId: itemId,
            ledgerId: ledgerDoc.id,
            userId: user.userId,
            userEmail: user.userEmail,
            workPackageId: workPackage.workPackageId
        }
        await FirebaseUsage.setDocumentWithDoc(ledgerDoc, ledgerEntry);

        await FirebaseUsage.updateDoc(COLLECTIONS.WORK_PACKAGES, workPackage.workPackageId, workPackage.completedChecklist ?
            {
                completedChecklist: [
                    ...workPackage.completedChecklist,
                    {id: itemId, timestamp: FirebaseUsage.timestamp()}]
            } :
            {completedChecklist: [{id: itemId, timestamp: FirebaseUsage.timestamp()}]})
    }

    public static async uncheckWorkPackageChecklistItem(
        workPackage: WorkPackage,
        itemId: string,
        contractId: string,
        user: UserDocModel
    ) {
        const ledgerDoc = FirebaseUsage.getBlankDoc(COLLECTIONS.LEDGER_ENTRY)
        const ledgerEntry = {
            projectId: workPackage.projectId,
            contractId: contractId,
            timestamp: FirebaseUsage.timestamp(),
            logTimestamp: FirebaseUsage.timestamp(),
            type: MessageType.CIU,
            checklistItemId: itemId,
            ledgerId: ledgerDoc.id,
            userId: user.userId,
            userEmail: user.userEmail,
            workPackageId: workPackage.workPackageId
        }
        await FirebaseUsage.setDocumentWithDoc(ledgerDoc, ledgerEntry);

        const completedChecklistMap = store.getState().task.completedChecklistMap;
        completedChecklistMap.delete(`${workPackage.workPackageId}:${itemId}`);
        await FirebaseUsage.updateDoc(COLLECTIONS.WORK_PACKAGES, workPackage.workPackageId, workPackage.completedChecklist ?
            {
                completedChecklist: [
                    ...workPackage.completedChecklist.filter((item) => item.id !== itemId)]
            } :
            {completedChecklist: []})
    }

    public static async addWorkPackageChecklistAttachment(
        workPackage: WorkPackage,
        checklistItemId: string,
        attachmentId: string,
        attachmentName: string
    ) {
        if (!workPackage || !workPackage.completedChecklist) return;
        const completedChecklist = workPackage.completedChecklist.map((item) =>
            item.id === checklistItemId ? ({
                ...item,
                attachments: item.attachments ?
                    [...item.attachments, {id: attachmentId, name: attachmentName}] :
                    [{id: attachmentId, name: attachmentName}]
            }) : item
        )
        await FirebaseUsage.updateDoc(COLLECTIONS.WORK_PACKAGES, workPackage.workPackageId, {
            completedChecklist: completedChecklist
        })
    }

    public static async removeWorkPackageChecklistAttachment(
        workPackage: WorkPackage,
        checklistItemId: string,
        attachmentId: string
    ) {
        if (!workPackage || !workPackage.completedChecklist) return;
        const completedChecklist = workPackage.completedChecklist.map((item) =>
            item.id === checklistItemId ? ({
                ...item,
                attachments: item.attachments ?
                    item.attachments.filter((attachment) => attachment.id !== attachmentId) :
                    []
            }) : item
        )
        await FirebaseUsage.updateDoc(COLLECTIONS.WORK_PACKAGES, workPackage.workPackageId, {
            completedChecklist: completedChecklist
        })
        await FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_FILES, attachmentId, {
            deleted: true
        })
    }
}